
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host(idb-icon-card){
  height:100%;
}

.idb-icon-card {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow-wrap: break-word;
  border-radius: 0.5rem;
  padding: 1rem;
}

@media (min-width: 768px) {

  .idb-icon-card {
    flex-direction: row;
  }

  .idb-icon-card {
    padding: 2rem;
  }
}

@media (min-width: 1280px) {

  .idb-icon-card {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .idb-icon-card {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

@media (min-width: 1440px) {

  .idb-icon-card {
    padding: 2rem;
  }
}

.idb-icon-card--bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

.idb-icon-card--bg-white {
  background-color: var(--neutral-white);
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

@media (min-width: 768px) {

  .header {
    margin-right: 1.5rem;
  }

  .header {
    flex-direction: row;
  }

  .header {
    gap: 1.5rem;
  }

  .header {
    text-align: left;
  }
}

@media (min-width: 1280px) {

  .header {
    margin-right: 1rem;
  }
}

@media (min-width: 1440px) {

  .header {
    margin-right: 1.5rem;
  }
}

.header{
  word-break:break-word;
}

.header a {
  margin-bottom: -1rem;
}

.header a {
  color: var(--blue-responsible-darken-2);
}

.header a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.header a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.header .icon {
  display: flex;
}

.header .icon {
  align-items: center;
}

.header .icon {
  color: var(--green-guarantee-lighten-2);
}

.subtitle {
  margin-bottom: 0.5rem;
  overflow: hidden;
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
}

::slotted([slot='subtitle']) {
  margin-bottom: 1rem;
  color: var(--gray-professional-lighten-1);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer a {
  display: flex;
}

.footer a {
  justify-content: flex-end;
}

.footer a {
  font-weight: var(--fw-bold);
}

.footer a {
  color: var(--blue-responsible-main);
}

.footer a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.footer a{
    gap:0.3rem;
  }

.footer a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.footer .icon {
  font-weight: var(--fw-bold);
}
`;